import type { ReactNode } from 'react'
import { cn } from '@/lib/utils'

type ActionBarProps = {
  title: ReactNode
  hint?: ReactNode
  meta?: ReactNode
  className?: string
  children: ReactNode
}

export function ActionBar({ title, hint, meta, className, children }: ActionBarProps) {
  return (
    <div
      className={cn(
        'sticky bottom-3 z-10 flex flex-wrap items-center gap-x-6 gap-y-3 rounded-2xl border bg-card/95 p-3 shadow-[0_12px_32px_-12px_color-mix(in_oklab,var(--shadow-color)_25%,transparent)] backdrop-blur sm:pl-4 dark:shadow-[0_12px_32px_-12px_color-mix(in_oklab,var(--black)_60%,transparent)]',
        className,
      )}
    >
      <div className="min-w-0">
        <p className="text-sm font-semibold">{title}</p>
        {hint ? <p className="text-xs text-muted-foreground">{hint}</p> : null}
      </div>
      {meta}
      <div className="flex w-full items-center gap-2 sm:ml-auto sm:w-auto [&>*]:flex-1 sm:[&>*]:flex-none">{children}</div>
    </div>
  )
}
